module.exports = __webpack_public_path__ + "static/media/picture-11@2x.92ad94b6.png";